export function useCopy() {
  const copy = (text: string) => navigator.clipboard.writeText(text)
  return { copy }
}
